import {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import BaseContentLayer from './BaseContentLayer';

interface Props {
  contentColor: LuiV3ColorKey;
}

const TextInheritContentLayer = styled(BaseContentLayer)<Props>`
  --btn-internals-full-padding: calc(var(--btn-size) / 4);
  --btn-internals-thin-padding: 0;
  color: inherit;
`;

export default TextInheritContentLayer;
